'use client';

import { useSelector } from 'react-redux';

import NordicsHeader from './components/header/nordics';
import GroupHeader from './components/header/group';
import { MegaMenuHeader } from './components/header/mega-menu/mega-menu-header';
import CountryHeader from './components/header/country';

import { useNord } from 'utils/hooks/use-nord';
import { globalsServerSelector, showMegaMenuSelector } from 'utils/selectors/globalsSelectors';
import { useGroup } from 'utils/hooks/use-group';
import { useIsLeadManagementLanding } from 'utils/hooks/use-is-lead-management-landing';
import { DummyHeader } from './components/header/dummy-header';

export default function Header() {
  const isNord = useNord();
  const isGroup = useGroup();
  const showMegaMenu = useSelector(showMegaMenuSelector);
  const server = useSelector(globalsServerSelector);
  const isLeadManagementLanding = useIsLeadManagementLanding(server);

  if (isLeadManagementLanding) {
    return <DummyHeader />;
  }

  if (isNord) {
    return <NordicsHeader />;
  }

  if (isGroup) {
    return <GroupHeader />;
  }

  if (showMegaMenu?.enabled) {
    return <MegaMenuHeader />;
  }

  return <CountryHeader />;
}
